import moment from 'moment';

import templateUrl from './rogers-owner-dashboard-container.component.html';
import "./rogers-owner-dashboard-container.component.less";

export const RogersOwnerDashboardContainerComponent = {
    controller: RogersOwnerDashboardContainerController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        icdCorporationID: "<"
    }
};

function RogersOwnerDashboardContainerController(apexApiUrl, divisionService,
    icdCorporationService, rogersDashboardService, utilityService) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.allowLoadingRogersDailyProductionReport = allowLoadingRogersDailyProductionReport;
    vm.endDate;
    vm.enableOnlyWeekday = enableOnlyWeekday;
    vm.icdCorporation;
    vm.icdCorporations;
    vm.onCalendarOpen = onCalendarOpen;
    vm.onRefresh = onRefresh;
    vm.onExportDailyProductionReport = onExportDailyProductionReport;
    vm.reportMode;
    vm.startDate;

    vm.reportModes = {
        dailyProductionReport: {
            title: "Daily Production"
        }
    };

    vm.dropdownOptions = {
        optionLabel: { Id: null, Text: 'All Owners' },
        dataSource: new kendo.data.DataSource({
            data: vm.icdCorporations,
        }),
        headerTemplate: `
                    <div style="padding: 8px 12px; border-bottom: 1px solid \\#ddd; cursor: pointer;">
                        <label class="control control-checkbox" style="margin: 0;">
                            <input type="checkbox" id="allcorps" name="allcorps" />
                            <span class="control-indicator"></span>
                            <span>Show Active</span>
                        </label>
                    </div>
                `,
        open: () => {
            setTimeout(() => {
                const widget = $("#corporation-list").data("kendoDropDownList");
                const source = vm.icdCorporations;
                $("#allcorps").off("click").on("click", (e) => {
                    const isChecked = $(e.target).prop("checked");

                    const filtered = isChecked
                        ? source.filter(c => c.IcdCorporationStatus === 'Active')
                        : source;
                    widget.dataSource.data(filtered);
                    widget.refresh();
                    widget.popup.open(); // keep it open after refresh
                });
            }, 0);
        }
    }

    //HACK because kendo doesn't give a way to pass variables from scope.
    // These functions will be globally available after constructing this controller
    $.setSunday = enableOnlyWeekday(0);
    $.setMonday = enableOnlyWeekday(1);

    function onInit() {
        // Default to loading data for the 10 weeks prior to the current day.
        vm.endDate = getUpcomingDayOfWeek(0); // Week endings fall on a Sunday.
        vm.startDate = moment(vm.endDate).add(-10, "weeks").toDate();

        vm.startDateOptions = { start: 'month', depth: 'day', disableDates: enableOnlyWeekday(1) };
        vm.endDateOptions = { start: 'month', depth: 'day', disableDates: enableOnlyWeekday(0) };

        vm.reportMode = vm.reportModes.dailyProductionReport;
        const loading = icdCorporationService.retrieveIcdCorporationsByModuleAdmin("Payout", {
            divisionID: divisionService.divisionIDs.Rogers
        })
            .then(function (icdCorporations) {
                icdCorporations.forEach(function (p) {
                    p.Text = kendo.format("{0} - {1}", p.Owner, p.ClientName);
                });
                vm.icdCorporations = icdCorporations.sort(function (a, b) {
                    return a.Text.toLowerCase() < b.Text.toLowerCase() ? -1 : 1;
                });
                vm.icdCorporation = icdCorporations.filter(function (icdCorporation) {
                    return icdCorporation.Id === vm.icdCorporationID;
                })[0] || (icdCorporations.length === 1 ? icdCorporations[0] : null);
                return vm.icdCorporation;
            });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(loading, "Initial load failed")
        );
    }

    function onExportDailyProductionReport() {
        const query = createDailyProductionReportOptionsParams();
        const queryString = utilityService.queryStringify(query);
        window.location = apexApiUrl + "dashboards/rogers/daily-production-report.xlsx" + queryString;
    }

    function allowLoadingRogersDailyProductionReport() {
        return vm.icdCorporation || vm.startDate && vm.endDate && vm.startDate <= vm.endDate;
    }

    function onRefresh() {
        if (!allowLoadingRogersDailyProductionReport()) {
            // Don't trigger a date reload, since the dates are required.
            return;
        }
        const dailyProductionReportLoaded = loadRogersDailyProductionReport(vm.icdCorporation);
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(dailyProductionReportLoaded, "Refreshing data failed"));
    }

    /**
     * Get the next date that falls on the given day of the week.
     * @param {Number} weekDay The day of the week, as an index starting with Sunday = 0.
     * @returns {Date} The next date that falls of the given day of the week.
     */
    function getUpcomingDayOfWeek(weekDay) {
        const currentWeekDay = new Date().getDay();
        return moment().add(weekDay < currentWeekDay ? weekDay - currentWeekDay + 7 : currentWeekDay - weekDay, "days")
            .startOf("day")
            .toDate();
    }

    function loadRogersDailyProductionReport() {
        const query = createDailyProductionReportOptionsParams();

        return rogersDashboardService.retrieveRogersDailyProductionReport(query)
            .then(function (report) {
                vm.dailyProductionReport = report;
            });
    }

    /**
     * Return a function that filters dates and only returns true if the day
     * of the week is the same as the given day of the week.
     * @param {Number} dayOfWeek
     * @returns {(date : Date) => boolean} A filter function for dates.
     */
    function enableOnlyWeekday(dayOfWeek) {
        return function (date) {
            return date.getDay() === dayOfWeek;
        };
    }

    /**
     * Create a query string for the daily production report from the current settings.
     * @returns {{ icdCorporationID : number, endDate : Date, maxWeeklyComparisons : Number }} The query object.
     */
    function createDailyProductionReportOptionsParams() {
        const query = {};
        if (vm.icdCorporation) {
            query.icdCorporationID = vm.icdCorporation.Id;
        }
        query.endDate = kendo.format("{0:yyyy-MM-dd}", vm.endDate);
        // The API is based on number of comparisons, so calculate number of weeks between the start and end date.
        query.maxWeeklyComparisons = Math.ceil(moment(vm.endDate).diff(vm.startDate, "weeks", true)) + 1;
        // Add 1 to the max because the end date is selected, so the diff will be 1 full week short.
        return query;
    }

    // Workaround since the version of kendo we are using does not support disabledDates

    function setDates() {
        $(".disabledDay").parent().removeClass("k-link");//removing this class makes the day unselectable
        $(".disabledDay").parent().removeAttr("href"); //this removes the hyperlink styling
    }

    function onCalendarOpen(dp) {
        setDates();
        if (dp.sender.dateView && dp.sender.dateView.calendar) {
            const cal = dp.sender.dateView.calendar;

            if (!cal.additionalNav) {
                //var navigate = cal.navigate;
                cal.bind('navigate', function () {
                    setDates();
                });
                cal.additionalNav = true;
            }
        }

    }
}
